import {MaterialDateMapping} from './material-planning.model';

export class MaterialPlanningWeekListPaginator {
  static readonly defaultPageElements = 10;
  private _weeks: MaterialDateMapping[];

  private firstVisibleIndex: number | null;

  private _lastDate: string | null | undefined;

  private _pageElements: number;

  constructor(weeks: MaterialDateMapping[], firstVisibleIndex?: number, pageElements?: number) {
    this._pageElements = pageElements ?? MaterialPlanningWeekListPaginator.defaultPageElements;
    this.reset(weeks);
    this.firstVisibleIndex = firstVisibleIndex ?? 0;
  }

  get weeks(): MaterialDateMapping[] {
    return this._weeks;
  }

  get lastDate(): string | null | undefined {
    return this._lastDate;
  }

  get pageElements(): number {
    return this._pageElements;
  }

  // keeps the last page filled when the page grows near the end of the loaded weeks
  set pageElements(pageElements: number) {
    this._pageElements = pageElements;
    const numWeeks = this._weeks?.length ?? 0;
    if (this.firstVisibleIndex !== null && this.firstVisibleIndex + pageElements > numWeeks) {
      this.firstVisibleIndex = Math.max(0, numWeeks - pageElements);
    }
  }

  get visibleWeekIndices(): number[] {
    const list = [];
    if (this.firstVisibleIndex !== null) {
      const end = Math.min(this.firstVisibleIndex + this._pageElements, this._weeks?.length ?? 0);
      for (let i = this.firstVisibleIndex; i < end; i++) {
        list.push(i);
      }
    }
    return list;
  }

  // returns true when page is one before the end
  get reloadPages(): boolean {
    return this.firstVisibleIndex > (this._weeks.length - this._pageElements - 2);
  }

  weekScrollPage(pages: number): void {
    if (this.firstVisibleIndex + pages < 0) {
      this.firstVisibleIndex = 0;
    } else if (this.firstVisibleIndex + pages + this._pageElements >= this._weeks.length) {
      this.firstVisibleIndex = Math.max(0, this._weeks.length - this._pageElements);
    } else {
      this.firstVisibleIndex += pages;
    }
  }

  addWeeks(weeks: MaterialDateMapping[]): void {
    weeks.forEach(week => {
      this._weeks.push(week);
    });

    this._lastDate = this._weeks[this._weeks.length - 1]?.first_day_of_week;
  }

  reset(weeks: MaterialDateMapping[]): void {
    this._weeks = weeks;
    const hasWeeks = (this._weeks && this._weeks.length > 0);
    this.firstVisibleIndex = hasWeeks ? 0 : null;
    this._lastDate = hasWeeks ? this._weeks[this._weeks.length - 1].first_day_of_week : null;
  }
}
